'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _themeSections = require('@shopify/theme-sections');

var _carousel = require('../components/carousel');

var _carousel2 = _interopRequireDefault(_carousel);

var _utils = require('../helpers/utils');

var _cssClasses = require('../helpers/cssClasses');

var _cssClasses2 = _interopRequireDefault(_cssClasses);

var _smoothscrollPolyfill = require('smoothscroll-polyfill');

var _smoothscrollPolyfill2 = _interopRequireDefault(_smoothscrollPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_smoothscrollPolyfill2.default.polyfill();

/**
 * DOM selectors.
 */
/**
 * Section: Image slider
 * ------------------------------------------------------------------------------
 * Large component displaying image galleries in a carousel.
 *
 * @namespace imageSlider
 */
var selectors = {
  stageOne: 'StageOne',
  container: '.fit-guide__slider',
  stageTwo: 'StageTwo',
  scrollStageTwo: '[js-fit-guide="stage-two"]',
  scrollStageThree: '[js-fit-guide="stage-three"]',
  scrollStageFour: '[js-fit-guide="stage-four"]',
  styleSlide: '[js-fit-guide="style-slide"]',
  fabricSlide: '[js-fit-guide="fabric-slide"]',
  nextStep: '[js-fit-guide="next-step"]',
  fabricContainer: '[js-fit-guide="fabric-container"]',
  headerBar: '[js-site-header="sticky"]'
};

/**
 * Instance globals.
 */
var imageSliderOne = {};
var imageSliderTwo = {};

/**
 * check mobile window width
 */

var initialWindowWidth = window.innerWidth;

/**
 * Defaults.
 */
var configOne = {
  cellSelector: '.fit-guide__slide',
  cellAlign: 'left',
  initialIndex: 0,
  pageDots: false,
  prevNextButtons: true,
  freeScroll: false,
  wrapAround: false,
  contain: true
};

var configTwo = {
  cellSelector: '.fit-guide__stage-two-slide',
  initialIndex: 0,
  prevNextButtons: true
};

/**
 * Image slider section constructor.
 * Executes on page load as well as Theme Editor `section:load` events.
 * @param {string} container - Selector for the section container DOM element.
 */
(0, _themeSections.register)('fit-guide__slider', {

  /**
   * Construct section events
   */
  onLoad: function onLoad() {
    var sectionId = this.id;
    this.setNodeSelectors();
    this.responsiveConfig(sectionId);
    this.createComponents(sectionId);
    this.setListeners(sectionId);
  },


  /**
   * Create sliders
   */
  createComponents: function createComponents(sectionId) {
    var sliderOne = '#' + selectors.stageOne + '-' + sectionId;
    var sliderTwo = '#' + selectors.stageTwo + '-' + sectionId;
    imageSliderOne[sectionId] = new _carousel2.default(sliderOne, configOne);
    imageSliderTwo[sectionId] = new _carousel2.default(sliderTwo, configTwo);
    imageSliderOne[sectionId].init();
    imageSliderTwo[sectionId].init();
  },
  responsiveConfig: function responsiveConfig(sectionId) {
    var sliderOneOptions = document.querySelector('#' + selectors.stageOne + '-' + sectionId);
    var sliderOneOffset = sliderOneOptions.dataset.slideOffset;
    var sliderOneAlign = sliderOneOptions.dataset.slideAlign;
    if ((0, _utils.isMediumUp)()) {
      configOne.cellAlign = sliderOneAlign;
      configOne.initialIndex = sliderOneOffset;
    } else {
      configOne.cellAlign = 'center';
    }
  },
  handleResize: function handleResize(sectionId) {
    var currentWindowWidth = window.innerWidth;

    /**
     * inivitalWindowWidth & currentWindowWidth are needed to prevent
     * mobile resize on scroll issue - https://developers.google.com/web/updates/2016/12/url-bar-resizing
    **/

    if (initialWindowWidth !== currentWindowWidth) {
      initialWindowWidth = currentWindowWidth;
      imageSliderOne[sectionId].destroy();
      imageSliderTwo[sectionId].destroy();
      this.responsiveConfig(sectionId);
      this.createComponents(sectionId);
    }
  },
  setListeners: function setListeners(sectionId) {
    var _this = this;

    this.styleSlide.forEach(function (item) {
      (0, _utils.on)('click', item, function (event) {
        return _this.selectedOption(event, item, sectionId, _this.scrollStageTwo);
      });
    });
    this.nextStep.forEach(function (button) {
      (0, _utils.on)('click', button, function (event) {
        return _this.selectedFabric(event, button, sectionId);
      });
    });
    this.fabricSlide.forEach(function (item) {
      (0, _utils.on)('click', item, function (event) {
        return _this.selectedOption(event, item, sectionId, _this.scrollStageFour);
      });
    });
    (0, _utils.on)('resize', function () {
      return _this.handleResize(sectionId);
    });
  },
  setNodeSelectors: function setNodeSelectors() {
    this.styleSlide = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(selectors.styleSlide)));
    this.fabricSlide = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(selectors.fabricSlide)));
    this.nextStep = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(selectors.nextStep)));
    this.fabricContainer = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(selectors.fabricContainer)));
    this.scrollStageTwo = document.querySelector(selectors.scrollStageTwo);
    this.scrollStageThree = document.querySelector(selectors.scrollStageThree);
    this.scrollStageFour = document.querySelector(selectors.scrollStageFour);
    this.headerBar = document.querySelector(selectors.headerBar);
  },


  /**
   * Set stage two slider to correct slide and move down to focus on stage two
   */
  selectedOption: function selectedOption(event, slide, sectionId, stage) {
    event.preventDefault();
    var slidePos = slide.dataset.slidePos;
    imageSliderTwo[sectionId].select(slidePos);
    this.moveToStage(stage);
    return false;
  },


  /**
   * Set stage three slider to correct slide and move down to focus on stage two
   */
  selectedFabric: function selectedFabric(event, button, sectionId) {
    var _this2 = this;

    event.preventDefault();
    var target = document.querySelector(button.getAttribute('href'));
    this.fabricContainer.forEach(function (item) {
      item.classList.remove(_cssClasses2.default.active);
    });
    target.classList.add(_cssClasses2.default.active);
    setTimeout(function () {
      _this2.moveToStage(_this2.scrollStageThree, sectionId);
    });
  },


  /**
   * Move the Document scroll position to the next stage
   */
  moveToStage: function moveToStage(stage) {
    var target = this.findTarget(stage);
    if (document.body.clientHeight < 401) {
      target = target + 250; // adding buffer to center fabrics for browser height below 401px;
    }

    window.__forceSmoothScrollPolyfill__ = true;
    window.scrollBy({
      top: target,
      left: 0,
      behavior: 'smooth'
    });
  },


  /**
   * Find pixel heigth on move scroll position
   */
  findTarget: function findTarget(element) {
    var targetHeight = element.getBoundingClientRect().top;
    var headerBar = this.headerBar.offsetHeight;
    var distanceScroll = targetHeight - headerBar;
    return distanceScroll;
  },


  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload: function onUnload() {
    imageSliderOne[this.id].reload();
    imageSliderTwo[this.id].reload();
  },


  /**
   * Event callback for Theme Editor `section:select` event
   */
  onSelect: function onSelect() {
    imageSliderOne[this.id].resize();
    imageSliderTwo[this.id].resize();
  }
});